import {ReactElement, ReactFragment} from "react";

type ConditionalProps = {
    condition: boolean;
    wrapper: (children: ReactFragment) => ReactElement;
    children: ReactFragment
}

const ConditionalWrapper = (props: ConditionalProps) =>{
    return (<>
        {props.condition ? 
            props.wrapper(props.children) : 
            props.children}
        </>);
};

export default ConditionalWrapper;